const getters = {
  subDomainConfig: state => {
    return state.subDomainConfig
  },
}
export default getters
